import { render, staticRenderFns } from "./IngresoDespacho.vue?vue&type=template&id=d1e95ab8&scoped=true"
import script from "./IngresoDespacho.vue?vue&type=script&lang=js"
export * from "./IngresoDespacho.vue?vue&type=script&lang=js"
import style0 from "./IngresoDespacho.vue?vue&type=style&index=0&id=d1e95ab8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1e95ab8",
  null
  
)

export default component.exports